var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title":_vm.$t('coding.title'),"description":_vm.$t('coding.description')}}),_c('ArticleStream',{attrs:{"items":_vm.$t('coding.infoList')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }